import React from 'react';
import { images } from 'utils';

interface ContainerProps {
	bg?: string;
	style?: any;
	text?: string;
}

const Loading: React.FC<ContainerProps> = ({ bg, style, text }) => {
	return (
		<React.Fragment>
			<div
				id="Loading"
				className="d-flex justify-content-center align-items-center"
				style={{
					height: '100dvh',
					backgroundColor: `${bg || '#fff'}`,
					flexDirection: 'column',
					...style,
				}}
			>
				<img
					src={images.LogoGif}
					alt="Logo"
					height={150}
					className="animate__animated_ animate__pulse animate__infinite"
				/>
				{text && <div className="mt-2 small text-muted">{text}</div>}
			</div>
		</React.Fragment>
	);
};

export default Loading;
